import api from "./api";

const settingsService = {
  get: () => api.get("/settings").then((r) => r.data),
  update: (payload) => api.put("/settings", payload).then((r) => r.data),
};

export default settingsService;
